import { eV1Protocol, eV1HostWithPort } from './hosts.js';

export type DynamicImportOptions = {
  host?: string;
  mediaData?: boolean;
};
export const dynamicImport = async (
  filePath: string,
  options: DynamicImportOptions = {},
): Promise<unknown> => {
  const host: string = options.host ?? eV1HostWithPort();

  // @ts-expect-error webpack should resolve this for us
  const taggedVersion: string = __TAGGED_VERSION__ as string;

  if (taggedVersion !== '' && taggedVersion.length > 0 && options.mediaData !== true) {
    return import(
      /* webpackIgnore: true */ `${eV1Protocol()}//${host}/${filePath}@${taggedVersion}`
    );
  }

  return import(/* webpackIgnore: true */ `${eV1Protocol()}//${host}/${filePath}`);
};
